(() => {
  const selectorRoot = "[data-stackable-v2]";
  const selectorScroller = "[data-stackable-v2-block3-scroller]";
  const selectorArrow = "[data-stackable-v2-arrow]";

  const sections = document.querySelectorAll(selectorRoot);
  if (!sections.length) return;

  sections.forEach((section) => {
    const scroller = section.querySelector(selectorScroller);
    if (!scroller) return;

    const arrows = Array.from(section.querySelectorAll(selectorArrow));
    if (!arrows.length) return;

    const items = Array.from(scroller.querySelectorAll(".pdp-stackable-v2__block3-item"));
    if (!items.length) return;

    const clampIndex = (index) => Math.min(items.length - 1, Math.max(0, index));

    const getClosestIndex = () => {
      const current = scroller.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const offset = item.offsetLeft - items[0].offsetLeft;
        const distance = Math.abs(offset - current);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const scrollToIndex = (index) => {
      const targetIndex = clampIndex(index);
      const targetItem = items[targetIndex];
      if (!targetItem) return;

      const firstOffset = items[0].offsetLeft;
      const targetLeft = targetItem.offsetLeft - firstOffset;

      scroller.scrollTo({
        left: targetLeft,
        behavior: "smooth",
      });
    };

    const update = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const hasOverflow = maxScroll > 1 && items.length > 1;
      const position = Math.abs(scroller.scrollLeft);
      const activeIndex = getClosestIndex();

      arrows.forEach((button) => {
        if (!hasOverflow) {
          button.hidden = true;
          button.disabled = true;
          return;
        }

        button.hidden = false;
        const isPrev = button.dataset.stackableV2Arrow === "prev";
        const atStart = activeIndex === 0 || position <= 1;
        const atEnd = activeIndex === items.length - 1 || position >= maxScroll - 1;

        button.disabled = isPrev ? atStart : atEnd;
      });
    };

    arrows.forEach((button) => {
      button.addEventListener("click", () => {
        const direction = button.dataset.stackableV2Arrow === "next" ? 1 : -1;
        const currentIndex = getClosestIndex();
        scrollToIndex(currentIndex + direction);
      });
    });

    scroller.addEventListener("scroll", () => {
      window.requestAnimationFrame(update);
    });

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(scroller);
    window.addEventListener("resize", update, { passive: true });
    window.addEventListener("load", update, { once: true });

    update();
  });
})();
